var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.extComponent)?_c('div',{staticClass:"extensions__wrapper"},[_c('div',{staticClass:"extensions__wrapper-burger"},[_c('MobileBurger')],1),_c(_vm.extComponent,{tag:"component",attrs:{"url":_vm.paramsString}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }